export default __webpack_public_path__ + "static/media/sports_score_white_24dp.1a54dbd7.svg";